import { render, staticRenderFns } from "./LargeAccordion.vue?vue&type=template&id=59876982"
import script from "./LargeAccordion.vue?vue&type=script&lang=js"
export * from "./LargeAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports